export enum OptionMenuApps {
  DM = "Journaling",
  PP = "Purpousing",
  MANTENEDOR = "Configuración",
  SEGUIMIENTO_REQID = "Seguimiento de RequestID",
  MERGE = "Merge",
  PROXIMA = "Próxima",
  LOGS = "Visualización de Logs",
  BULK = "Update / Delete Masivo",
  MENU_RDS = "RDS",
  DISOCIAR = "Disociar",
  CONTRIBUTION = "Seguimiento de Contribución"
}

export enum OptionAbmMenu {
  GLOBAL = "Global",
  FUENTES_INT = "Journaling",
  FUENTES_VIP = "Journaling VIP",
  SEARCH_INTERNO = "Motor de búsqueda",
  SEARCH_VIP = "Motor de búsqueda VIP",
  RDS = "RDS",
  PROFILE_REGION = "Profile Región",
  PURPOSING = "Purposing"
}
